module.exports = __webpack_public_path__ + "images/help/icon-handwritting-61a3f458c0a868cf44028fb2c6d7b56c.png";